module.exports = __webpack_public_path__ + "phone.png?c8164c42cf9e7710b12ac45089847407";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone.png
// module id = 105
// module chunks = 0